export const BASENAME = ''; // don't add '/' at end off BASENAME for breadcrumbs
export const BASE_URL = '/app/dashboard/analytics';
export const BASE_TITLE = ' | New Insync App';

// export const IMGURL = 'http://192.168.0.250:8440/api/usr/download/';
// export const API_URL = 'http://192.168.0.250:8440/api/auth/';
// export const API_URLU = 'http://192.168.0.250:8440/api/usr/';

 export const IMGURL = 'https://marketservant.com:8444/api/usr/download/';
 export const API_URL = 'https://marketservant.com:8444/api/auth/';
 export const API_URLU = "https://marketservant.com:8444/api/usr/";

  // export const IMGURL = 'http://localhost:8444/api/usr/download/';
  // export const API_URL = 'http://localhost:8444/api/auth/';
  // export const API_URLU = 'http://localhost:8444/api/usr/';

// export const IMGURL = 'http://localhost:8440/api/usr/download/';
// export const API_URL = 'http://localhost:8440/api/auth/';
// export const API_URLU = 'http://localhost:8440/api/usr/';



export const CONFIG = {
  layout: 'vertical', // vertical, horizontal
  subLayout: '', // horizontal-2
  collapseMenu: false, // mini-menu
  layoutType: 'menu-light', // menu-dark, menu-light, dark
  headerBackColor: 'header-darkblue', // header-orchidgreen, header-blue, header-red, header-purple, header-info, header-green header-dark
  rtlLayout: false,
  navFixedLayout: true,
  headerFixedLayout: true,
  boxLayout: false,
  jwt: {
    secret: 'SECRET-KEY',
    timeout: '1 days'
  },
  firebase: {
    apiKey: 'AIzaSyC9m6rMXs8PKHkJaT761AupFQdmcjQDwSY',
    authDomain: 'gradient-able-react-hook.firebaseapp.com',
    projectId: 'gradient-able-react-hook',
    storageBucket: 'gradient-able-react-hook.appspot.com',
    messagingSenderId: '787384589233',
    appId: '1:787384589233:web:2b57c391ac41d2d1967b90',
    measurementId: 'G-1D6ER7YWLL'
  },
  auth0: {
    client_id: 'CkaKvwheIhIQkybjTEQwN7ikcdHObsPh',
    domain: 'dev-w0-vxep3.us.auth0.com'
  }
};
